import { makeStyles } from '@material-ui/core/styles';
export const drawerWidth = 240;
const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#1c1c1c',
    color: '#fff',
    scrollbarColor: '#888888 transparent',
    scrollbarWidth: 'thin',
  },
  drawer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    backgroundColor: '#1c1c1c',
    padding: '24px 16px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  logo: {
    padding: '0 8px',
    height: '32px',
    cursor: 'pointer',
  },
  separater: {
    margin: '0.2rem 0',
    borderTop: '1px solid #404040',
  },
  subDrawerList: {
    margin: '8px 0 8px 18px',
    padding: '0 0 0 12px',
    borderLeft: '1px solid #404040',
  },
  drawerListItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0rem',
    padding: '8px',
    borderRadius: '4px',
    height: '36px',
    cursor: 'pointer',
    transition: 'background-color 150ms',
    '&:hover': {
      backgroundColor: '#232323',
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: '#292929',
    },
  },
  subDrawerListItem: {
    padding: '8px 12px',
    borderRadius: '4px',
    height: '32px',
    cursor: 'pointer',
    transition: 'background-color 150ms',
    '&:hover': {
      backgroundColor: '#232323',
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: '#292929',
    },
  },
  drawerListTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  drawerListText: {
    fontWeight: '400',
    fontSize: '14px',
  },
  subDrawerListText: {
    fontWeight: '400',
    fontSize: '13px',
  },
  drawerListImg: {
    width: '24px!important',
  },
  discordImg: {
    padding: '0 2px',
    width: '24px!important',
  },
  drawerBetaImg: {
    color: '#fff',
    width: '24.6px!important',
    height: '8.2px!important',
    marginBottom: '1.1rem',
  },
  languageContainer: {
    cursor: 'pointer',
    display: 'flex',
    padding: '8px',
    marginTop: '12px',
    alignItems: 'center',
  },
  selectedLanguage: {
    margin: '0 8px',
    fontWeight: '400',
    fontSize: '14px',
  },
  expandIcon: {
    fontSize: '20px!important',
  },
  subHeader: {
    padding: '0 8px',
    fontSize: '12px',
    fontWeight: '300',
    color: '#888888',
    marginTop: '20px',
    marginBottom: '8px',
  },
}));

export { useStyles };
